<template>
<section style="width:100%;height:100%;">
  <a-map ref="map" :features="['bg', 'road', 'point']" map-style="normal" />
  <wind-field :data="windFieldData" :is-satellite-mode="isSatelliteMode" />

  <section class="map-toolbar">
    <el-radio-group
      v-model="isSatelliteMode"
      size="small"
      style="float:right;margin-left:1rem;"
      @change="onSatelliteModeChanged"
    >
      <el-radio-button :label="true">卫星地图</el-radio-button>
      <el-radio-button :label="false">电子地图</el-radio-button>
    </el-radio-group>
    <el-select
      v-if="!isSatelliteMode"
      v-model="styleColor"
      size="small"
      style="float: right;margin-left: 1rem;width: 130px;"
      @change="setStyle"
    >
      <el-option
        v-for="item in styleOptions"
        :key="item.value"
        :label="item.name"
        :value="item.value">
      </el-option>
    </el-select>
  </section>
</section>
</template>

<script>
import AMap from '../../components/Map/index'
import * as EventKeyMap from '../../components/Map/EventKeys'
import WindField from '../../components/WindField/index'

// import data from './2017121300.json'
// import demo from './demo'

export default {
  name: 'SiteDeviceInfoMap',
  components: {WindField, AMap},
  props: {
    siteInfos: {
      required: true,
      type: Array
    },
    getWindowContent: {
      type: Function
    }
  },
  data () {
    return {
      isSatelliteMode: false,
      windFieldData: null,
      styleColor: 'normal',
      source: '',
      newDateTime: ''
    }
  },
  computed: {
    styleOptions () {
      return [{
        name: '标准',
        value: 'normal'
      }, {
        name: '幻影黑',
        value: 'dark'
      }, {
        name: '月光银',
        value: 'light'
      }, {
        name: '远山黛',
        value: 'whitesmoke'
      }, {
        name: '草色青',
        value: 'fresh'
      }, {
        name: '雅士灰',
        value: 'grey'
      }, {
        name: '涂鸦',
        value: 'graffiti'
      }, {
        name: '马卡龙',
        value: 'macaron'
      }, {
        name: '靛青蓝',
        value: 'blue'
      }, {
        name: '极夜蓝',
        value: 'darkblue'
      }, {
        name: '酱籽',
        value: 'wine'
      }]
    }
  },
  methods: {
    setStyle (item) {
      this.map.setMapStyle(item)
    },
    onSatelliteModeChanged (isSatelliteMode) {
      this.$refs.map.onSatelliteModeChange(isSatelliteMode)
    },
    onTextMouseOver (event) {
      let {getWindowContent} = this

      if (!getWindowContent) {
        return
      }

      let {target} = event
      let content = getWindowContent(target.getExtData())

      if (!content) {
        this.infoWindow.close()
        return
      }

      let {infoWindow} = this
      infoWindow.setContent(content)
      infoWindow.open(this.map.map, target.getPosition())
    },
    onTextMouseOut (event) {
      this.infoWindow.close()
    },
    getStyle (site) {
      return {
        'font-size': '14px',
        padding: '0 0 6px 0',
        border: 0,
        'background': 'transparent',
        color: '#fff'
      }
    },
    createText (map, site) {
      let text = map.createText({
        text: `<div class="map-site-name-text" style="--site-bg:${site.bgColor}">${site.name}</div>`,
        position: map.createLngLat(site.longitude, site.latitude),
        style: this.getStyle(site),
        clickable: true,
        topWhenClick: true,
        extData: site
      })

      text.on('mouseover', this.onTextMouseOver)
      text.on('mouseout', this.onTextMouseOut)

      return text
    },
    render (flag) {
      let {siteInfos} = this

      if (siteInfos.length === 0) {
        return
      }

      let {map, siteTexts, createText} = this

      if (siteTexts) {
        siteInfos.forEach(site => {
          let {id} = site
          let text = siteTexts[id]

          if (text) {
            siteTexts[id] = createText(map, site)
          } else {
            text.setStyle(this.getStyle(site))
          }
        })
      } else {
        this.siteTexts = siteInfos.reduce((siteTextMap, site) => {
          siteTextMap[site.id] = createText(map, site)
          return siteTextMap
        }, {})
      }

      if (flag) {
        this.map.setFitView(Object.values(this.siteTexts))
        this.map.setZoom(Math.min(this.map.getZoom(), process.env.HOME_MIN_ZOOM))
      }
    },
    createInfoWindow () {
      this.infoWindow = this.map.createInfoWindow({
        offset: this.map.createPixel(0, -23),
        isCustom: true,
        retainWhenClose: true
      })
    },
    onMapCreated (map) {
      this.map = map
      this.render(true)
      this.createInfoWindow()
    },
    onMapDestroy () {
      this.$destroy()
    },
    clear () {
      let {siteTexts} = this

      if (!siteTexts) {
        return
      }

      siteTexts = Object.values(siteTexts)

      siteTexts.forEach(text => {
        text.off('mouseover', this.onTextMouseOver)
        text.off('mouseout', this.onTextMouseOut)
        text.setMap(null)
      })

      this.siteTexts = null
    }
  },
  watch: {
    siteInfos (siteInfos, oldSiteInfos) {
      if (!this.map) {
        return
      }

      this.render(!Array.isArray(oldSiteInfos) || oldSiteInfos.length === 0)
    }
  },
  created () {
    this.$api.Overview.getWindField().then(data => {
      this.windFieldData = Object.freeze(data)
      this.newDateTime = new Date(data[0].header.refTime).format('YYYY-MM-DD HH:mm:ss')
      this.source = data[0].header.centerName
    }).catch(console.error)
  },
  mounted () {
    let {$eventBus} = this
    $eventBus.once(EventKeyMap.MAP_CREATED, this.onMapCreated)
    $eventBus.once(EventKeyMap.MAP_DESTROY, this.onMapDestroy)
  },
  beforeDestroy () {
    this.clear()
  }
}
</script>

<style lang="scss" scoped>
.map-toolbar {
  position: absolute;
  top: 20px;
  right: 10px;
}
.amap-info-contentContainer {
  padding-bottom: 0 !important;
}

.el-radio-group {
  opacity: .8;
}

.el-select /deep/ .el-input__inner {
  background: RGBA(255, 255, 255, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/views/01Data-Overview/SiteDeviceInfoMap.vue